<template>
  <div class="BaseAccountRepDisplay__account-manager bg-white column">
    <label class="fw-med fc-mid fs-14 mb-8 no-select no-wrap">
      YOUR ACCOUNT REP:
    </label>
    <label class="fc-dark fs-12 mb-4 no-select">
      <i class="fa fa-user fc-light" />{{
        `${accountManager.first_name.trim()} ${accountManager.last_name.trim()}`
      }}
    </label>
    <a
      class="fc-blue fs-12 mb-4 row row--align-center no-wrap"
      :href="`mailto:${accountManager.user.email}`"
    >
      <i class="fa fa-mail fc-light" />
      {{ accountManager.user.email }}
    </a>
    <label class="fc-dark fs-12 row row--align-center no-wrap mb-4">
      <i class="fa fa-phone" />
      (410) 204-2084 {{ accountManager.extension ? `ext ${accountManager.extension}` : '' }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'BaseAccountRepDisplay',

  props: {
    accountManager: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="sass">
.BaseAccountRepDisplay

  &__account-manager
    border: $border
    border-radius: $border-radius
    margin-top: rem(56px)
    padding: rem(17px)

    .fa
      margin-right: rem(8px)

    .fa-user
      font-size: rem(19px)

    .fa-mail
      font-size: rem(14px)

    .fs-phone
      font-size: rem(18px)
</style>
